var React = require('react');

function ArrowRight (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"none","fillRule":"evenodd","strokeLinecap":"round","strokeLinejoin":"round"},React.createElement("g",{"stroke":"currentColor","strokeWidth":"2"},React.createElement("g",null,React.createElement("path",{"d":"M0 4.5L12 4.5M7.5 0L12 4.5 7.5 9","transform":"translate(-1114 -685) translate(1115 686)"})))));
}

ArrowRight.defaultProps = {"width":"14","height":"11","viewBox":"0 0 14 11"};

module.exports = ArrowRight;

ArrowRight.default = ArrowRight;
